import { Mask } from '../mask.interface';

export class CurrencyModel implements Mask {

  private currencyMask = (_value: string): (string | RegExp)[] | Function | boolean => {

    const value = _value.replace(/[^0-9]+/g, '');

    // Segunda interação, o usuário digita um valor acima de centava é captado aqui pois o tamanho fica: 0,01x (x = valor que foi digítado);
    if (value.length === 4) {
      if (value[0] !== '0') {
        // Se o primeiro digíto não for zero significa que o usuário está digitando um valor já nas casas decimais.
        return ['R', '$', ' ', /\d/, /\d/, ',', /\d/, /\d/];
      } else {
        // Se o primeiro digíto ainda for zero significa que o usuário ainda não passou para as casas decimais.
        return ['R', '$', ' ', value[1], ',', value[2], value[3]];
      }
    } else if (value.length === 5) {
      // Terceira interação, significa que o usuário está nas casas de centena.
      return ['R', '$', ' ', /\d/, /\d/, /\d/, ',', /\d/, /\d/];
    } else if (value.length === 2) {
      if (value[0] === '0') {
        return ['R', '$', ' ', '0', ',', '0', /\d/];
      } else {
      return ['R', '$', ' ', '0', ',', /\d/, /\d/];
      }
      // Essa interação representa quando o usuário está apagando um valor.
    } else if (value.length === 3) {
      // Essa interação representa quando o usuário está apagando um valor.
      return ['R', '$', ' ', /\d/, ',', /\d/, /\d/];
    } else if (value.length === 6) {
      // Quarta interação, significa que o usuário está nas casas de milha.
      if (value[0] === '.' && value[4] === ',') {
        return ['R', '$', ' ', /\d/, /\d/, /\d/, ',', /\d/, /\d/];
      } else if (value[0] === '.' && value[3] === ',') {
        return ['R', '$', ' ', /\d/, /\d/, /\d/, ',', /\d/, /\d/];
      } else {
        return ['R', '$', ' ', /\d/, '.', /\d/, /\d/, /\d/, ',', /\d/, /\d/];
      }
    }else if (value.length >= 7) {
      // Limite de casas.
      return ['R', '$', ' ', /\d/, '.', /\d/, /\d/, /\d/, ',', /\d/, /\d/];
    } else {
      // Primeira interação, retorna a mascára pronta para adicionar um valor como centavo.
      return ['R', '$', ' ', '0', ',', '0', /\d/];
    }
  }

  getMaskRule(): (string | RegExp)[] | Function | boolean {
    return this.currencyMask;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/currency.model.ts